function Privacy() {
  return (
    <div class="sub max-w-4xl mx-auto px-4 py-8">
      <h1 class="text-3xl font-bold mb-6">딥플랩스 개인정보 처리방침</h1>
      <section class="mb-8">
        <p class="mb-2">
          주식회사 딥플랩스(이하 '회사')는 이용자의 개인정보를 소중히 다루고 있습니다. 회사는
          「정보통신망 이용촉진 및 정보보호 등에 관한 법률」을 비롯한 관련
          법규상의 개인정보 보호규정 및 개인정보 보호지침을 준수하며, 관련
          법령에 의거한 개인정보 처리방침을 제정하여 이용자의 권익 보호에 최선을
          다하고 있습니다.
        </p>
        <h2 class="text-2xl font-semibold mb-4">딥플랩스 개인정보 처리방침</h2>

        <p class="mb-2">
          주식회사 딥플랩스(이하 '회사')는 이용자의 동의를 받아 개인정보를 수집·이용 및
          제공하고 있습니다. 또한 이용자의 개인정보 자기결정권을 적극적으로
          보장합니다. 회사는 개인정보 처리방침을 통해 수집하는 개인정보의 종류,
          이용목적, 처리방침 등을 안내하고 개인정보보호를 위해 어떠한 조치가
          취해지고 있는지 알려드림으로써 이용자가 보장된 권리에 따라 안심하고
          서비스를 이용할 수 있도록 노력하고 있습니다.
        </p>
        <ul class="list-disc list-inside mt-4 space-y-1 text-sm text-gray-400">
          <li>수집하는 개인정보 항목 및 수집방법</li>
          <li>개인정보의 수집 및 이용 목적</li>
          <li>개인정보의 보유 및 이용 기간</li>
          <li>개인정보의 처리 위탁</li>
          <li>개인정보의 공개 및 연동</li>
          <li>개인정보 파기절차 및 방법</li>
          <li>회원 및 법정대리인의 권리와 그 행사방법</li>
          <li>개인정보의 기술적·관리적 보호 대책</li>
          <li>개인정보에 관한 민원서비스</li>
          <li>기타</li>
          <li>고지의 의무</li>
        </ul>
      </section>
      <section class="mb-8">
        <h2 class="text-2xl font-semibold mb-4">
          수집하는 개인정보 항목 및 수집방법
        </h2>

        <h3 class="text-xl font-medium mt-4 mb-2">1) 수집하는 개인정보 항목</h3>
        <p class="font-semibold">가. 수집하는 정보</p>
        <p className="text-sm text-gray-400 mb-2">
          회사는 회원가입, 원활한 고객상담, 각종 서비스의 제공 및 고객관리를
          위해 아래와 같은 개인정보를 수집하고 있습니다. 선택수집 항목은
          입력하지 않아도 회원가입이 가능합니다.
        </p>
        <ul class="list-disc list-inside text-sm text-gray-400">
          <li>
            <strong>필수수집 항목:</strong> 휴대폰 번호, 닉네임, 출생년도, 성별,
            학력, 직업, 지역, 키, 흡연여부, 음주빈도, 종교여부, 사진
          </li>
          <li>
            <strong>선택수집 항목:</strong> 카카오톡 아이디, 연봉, 차량보유 여부
          </li>
        </ul>

        <p class="font-semibold mt-4">
          나. 서비스 이용과정이나 사업처리 과정에서의 수집정보
        </p>
        <ul class="list-disc list-inside text-sm text-gray-400">
          <li>
            IP Address, 방문 일시, 서비스 이용 기록, 불량 이용 기록, 접속 로그,
            채팅내역
          </li>
          <li> 사용 이동통신사 등</li>
          <li> 서비스 사용 중일 때 귀하의 모바일 기기의 지리적 위치</li>
          <li> 모바일 단말기 정보, 국가정보 (MCC)</li>
          <li> 광고 식별자 정보 (ADID, IDFA)</li>
        </ul>

        <h3 class="text-xl font-medium mt-4 mb-2">2) 개인정보 수집방법</h3>
        <p className="text-sm text-gray-400 mb-2">
          회사는 다음과 같은 방법으로 개인정보를 수집하고 있습니다.
        </p>
        <ul class="list-disc list-inside text-sm text-gray-400">
          <li>
            회원가입 및 서비스 이용과정에서 개인정보 수집에 대해 동의를 하고
            직접 정보를 입력
          </li>
          <li>모바일앱, 서면 양식, 전화, FAX, 문의메일</li>
          <li>협력회사로부터 공동 제휴 및 협력을 통한 정보 수집</li>
        </ul>
      </section>
      <section class="mb-8">
        <h2 class="text-2xl font-semibold mb-4">
          개인정보의 수집 및 이용 목적
        </h2>
        <p className="text-sm text-gray-400 mb-2">
          회사는 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는
          개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이
          변경되는 경우에는 개인정보 보호법 제 18조에 따라 별도의 동의를 받는 등
          필요한 조치를 이행할 예정입니다.
        </p>
        <h3 class="text-xl font-medium mt-4 mb-2">
          1) 서비스 제공에 관한 계약 이행, 부가서비스 제공 및 회원 관리
        </h3>
        <p className="text-sm text-gray-400 mb-2">
          매칭 서비스 및 콘텐츠 제공에 따른 본인확인, 개인 식별, 가입의사 확인,
          연령 확인, 가입 및 가입횟수 제한, 부가서비스 제공을 위한 고유 이용자
          특정, 불량회원의 부정이용 및 비인가 사용 방지, 회원탈퇴 후 24시간내
          재가입 방지, 불만처리 등 민원처리, 분쟁조정을 위한 기록보존, 안내사항
          전달, 회원탈퇴 의사의 확인
        </p>
        <h3 class="text-xl font-medium mt-4 mb-2">2) 마케팅 및 광고에 활용</h3>
        <p className="text-sm text-gray-400 mb-2">
          신규 서비스(제품) 개발 및 특화, 이벤트 등 광고성 정보 전달,
          인구통계학적 특성에 따른 서비스 제공 및 광고 게재, 접속 빈도 파악 또는
          회원의 서비스 이용에 대한 통계, 서비스의 유효성 확인
        </p>
        <h3 class="text-xl font-medium mt-4 mb-2">
          3) 수집한 개인정보 이용 및 제 3자 제공
        </h3>
        <p className="text-sm text-gray-400 mb-2">
          회사는 통계작성, 학술연구 또는 시장조사를 위하여 필요하다면 이용자가
          제공한 개인정보를 식별할 수 없는 형태로 가공하여 제3자에게 제공할 수
          있습니다.
        </p>
      </section>
      <section class="mb-8">
        <h2 class="text-2xl font-semibold mb-4">
          개인정보의 보유 및 이용 기간
        </h2>
        <p className="text-sm text-gray-400 mb-2">
          개인정보는 수집 및 이용목적이 달성되면 지체 없이 파기합니다. 단,
          다음의 정보에 대해서는 하기의 이유로 회원탈퇴 후에도 명시한 기간 동안
          해당 정보를 보존합니다.
        </p>
        <h3 class="text-xl font-medium mt-4 mb-2">
          1) 회사 내부 방침에 의한 정보보유 사유
        </h3>
        <ul class="list-disc list-inside text-sm text-gray-400">
          <li>
            가. 부정이용 기록
            <ul class="list-disc list-inside text-sm text-gray-400">
              <li>
                보존 항목 : 부정이용기록(부정가입, 규정위반 기록 등 비정상적
                서비스 이용기록)
              </li>
              <li>보존 이유 : 부정가입 및 부정이용 방지</li>
              <li>보존 기간 : 3년</li>
            </ul>
          </li>
          <li>
            나. 회원의 부정이용 방지와 비인가 사용방지
            <ul class="list-disc list-inside text-sm text-gray-400">
              <li>
                보존 항목 : 채팅내역 (각종 범법행위 방지 및 수사 협조를 위한
                데이터 저장)
              </li>
              <li>보존 이유 : 부정이용 방지와 비인가 사용방지</li>
              <li>보존 기간 : 30일</li>
            </ul>
          </li>
          <li>
            다. 반복적 탈퇴/재가입 방지를 위한 정보
            <p>
              회원 탈퇴한 경우에는 회원 재가입, 임의 해지 등을 반복적으로
              행함으로써 회사가 제공하는 서비스의 부정이용 및 이벤트 혜택 등의
              이익 등을 불·편법적으로 수취하거나 이 과정에서 명의도용 등의
              우려가 있으므로 이러한 행위의 차단 목적으로 회원 탈퇴 후 3개월
              동안 회원정보를 보관합니다.
            </p>
            <ul class="list-disc list-inside text-sm text-gray-400">
              <li>보존 항목 : 이메일주소, 휴대폰 번호, 기기 정보</li>
              <li>보존 이유 : 재가입, 임의해지 등의 부정이용 방지</li>
              <li>보존 기간 : 3개월</li>
            </ul>
          </li>
          <li>
            라. 개인정보 유효기간제 도입에 따른 개인정보 분리보관 및 휴면계정의
            복원을 위한 정보
            <p>
              서비스를 장기간 이용하지 않는 이용자의 회원정보에 포함된
              개인정보는 별도로 분리보관 됩니다. 서비스를 재이용하고 싶은
              경우에는 휴면해지처리 선택을 거쳐 정상 아이디로 복원할 수
              있습니다.
            </p>
            <ul class="list-disc list-inside text-sm text-gray-400">
              <li>
                분리보관 항목 : 회원정보에 포함된 개인정보(필수, 선택정보 포함)
              </li>
              <li>
                분리보관 기준 : 기준 시점으로부터 1년 내 미로그인한 경우
                휴면계정으로 전환 및 개인정보 분리보관
              </li>
              <li>
                분리보관 제외 : 휴면통지 및 복원에 필요한 정보, 법령의 규정 및
                내부 규정에 따라 보존할 필요성이 있는 정보 제외
              </li>
              <li>
                분리보관 이유 : 「정보통신망 이용촉진 및 정보보호 등에 관한
                법률」에 따른 장기 미이용자 개인정보 보호
              </li>
              <li>분리보관 기간 : 휴면계정 전환 이후 1년</li>
            </ul>
          </li>
        </ul>
        <h3 class="text-xl font-medium mt-4 mb-2">
          2) 관련법령에 의한 정보보유 사유
          <p className="text-sm text-gray-400 mb-2">
            「전자상거래 등에서의 소비자보호에 관한 법률」 등 관계법령의 규정에
            의하여 보존할 필요가 있는 경우 회사는 관계법령에서 정한 일정한 기간
            동안 회원정보를 보관합니다. 이 경우 회사가 보관하는 정보를 그 보관의
            목적으로만 이용하며 보존기간은 아래와 같습니다.
          </p>
        </h3>
        <ul class="list-disc list-inside text-sm text-gray-400">
          <li>
            가. 계약 또는 청약철회 등에 관한 기록
            <ul class="list-disc list-inside text-sm text-gray-400">
              <li>보존 이유 : 전자상거래 등에서의 소비자보호에 관한 법률</li>
              <li>보존 기간 : 5년</li>
            </ul>
          </li>
          <li>
            나. 대금결제 및 재화 등의 공급에 관한 기록
            <ul class="list-disc list-inside text-sm text-gray-400">
              <li>보존 이유 : 전자상거래 등에서의 소비자보호에 관한 법률</li>
              <li>보존 기간 : 5년</li>
            </ul>
          </li>
          <li>
            다. 소비자의 불만 또는 분쟁처리에 관한 기록
            <ul class="list-disc list-inside text-sm text-gray-400">
              <li>보존 이유 : 전자상거래 등에서의 소비자보호에 관한 법률</li>
              <li>보존 기간 : 3년</li>
            </ul>
          </li>
          <li>
            라. 앱 접속 기록
            <ul class="list-disc list-inside text-sm text-gray-400">
              <li>보존 이유 : 통신비밀보호법</li>
              <li>보존 기간 : 2년</li>
            </ul>
          </li>
          <li>
            마. 경품 등의 제공에 따른 제세공과금 처리 관련 항목
            <ul class="list-disc list-inside text-sm text-gray-400">
              <li>보존 이유 : 소득세법</li>
              <li>보존 기간 : 5년</li>
            </ul>
          </li>
          <li>
            바. 서비스 이용 기록, 접속 로그, 접속 IP 정보{" "}
            <ul class="list-disc list-inside text-sm text-gray-400">
              <li>보존 이유 : 통신비밀보호법</li>
              <li>보존 기간 : 3개</li>
            </ul>
          </li>
          <li>
            사. 표시·광고에 관한 기록
            <ul class="list-disc list-inside text-sm text-gray-400">
              <li>보존 이유 : 전자상거래 등에서의 소비자보호에 관한 법률</li>
              <li>보존 기간 : 6개월</li>
            </ul>
          </li>
        </ul>
        <h3 class="text-xl font-medium mt-4 mb-2">
          개인정보의 처리 위탁
          <p className="text-sm text-gray-400 mb-2">
            회사는 서비스 제공에 있어 필요한 업무 중 일부를 외부 업체로 하여금
            수행하도록 개인정보를 위탁하고 있으며, 위탁계약 체결 시 개인정보
            보호법 제26조에 따라 위탁업무 수행목적 외 개인정보 처리금지,
            기술적·관리적 보호조치, 재위탁 제한, 수탁자에 대한 관리·감독,
            손해배상 등 책임에 관한 사항을 계약서 등 문서에 명시하고, 수탁자가
            개인정보를 안전하게 처리하는지를 감독하고 있습니다. 위탁업무의
            내용이나 수탁자가 변경될 경우에는 지체없이 본 개인정보 처리방침을
            통해 공개하도록 하겠습니다.
          </p>
        </h3>
        <ul class="list-disc list-inside text-sm text-gray-400">
          <li>
            가. Google Play 스토어
            <ul class="list-disc list-inside text-sm text-gray-400">
              <li>위탁업무 : 인앱결제</li>
              <li>연락처 : 080-234-0051</li>
            </ul>
          </li>
        </ul>
        <ul class="list-disc list-inside text-sm text-gray-400">
          <li>
            나. 애플 스토어
            <ul class="list-disc list-inside text-sm text-gray-400">
              <li>위탁 업무 : 인앱 결제</li>
              <li>
                연락처 : &nbsp;
                <a
                  href="http://apple.com/legal/privacy/contact"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Apple Legal - Legal - Privacy - Apple
                </a>
              </li>
            </ul>
          </li>
        </ul>
        <ul class="list-disc list-inside text-sm text-gray-400">
          <li>
            다. 카카오톡
            <ul class="list-disc list-inside text-sm text-gray-400">
              <li>위탁업무 : 고객문의</li>
              <li>연락처 : 1577-3754</li>
            </ul>
          </li>
        </ul>
        <ul class="list-disc list-inside text-sm text-gray-400">
          <li>
            라. Amazon Web Service
            <ul class="list-disc list-inside text-sm text-gray-400">
              <li>위탁업무 : 시스템운영 및 데이터보관</li>
              <li>
                연락처 : &nbsp;
                <a
                  href="mailto:aws@amazon.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  aws@amazon.com
                </a>
              </li>
            </ul>
          </li>
        </ul>
        <ul class="list-disc list-inside text-sm text-gray-400">
          <li>
            마. Google Cloud Platform
            <ul class="list-disc list-inside text-sm text-gray-400">
              <li>위탁업무 : 시스템운영 및 데이터보관</li>
              <li>연락처 : Cloud Console의 지원 페이지</li>
            </ul>
          </li>
        </ul>
        <h3 class="text-xl font-medium mt-4 mb-2">
          개인정보의 공개 및 연동
          <p className="text-sm text-gray-400 mb-2">
            회사는 이용자의 동의가 있거나 법률의 규정에 의한 경우를 제외하고는
            어떠한 경우에도 이용 범위를 넘어 이용자의 개인정보를 이용하거나
            외부에 공개하지 않습니다. 이용자의 개인정보를 외부와 공유하는
            경우에는 사전에 해당 사실을 알리고 동의를 구하는 절차를 거치게 되며,
            이용자들의 동의가 없는 경우에는 추가적인 정보를 임의로 수집하거나
            공유하지 않습니다. 단, 아래의 경우는 예외로 합니다.
          </p>
        </h3>
        <h3 class="text-xl font-medium mt-4 mb-2">
          1) 이용자가 동의한 경우
          <ul class="list-disc list-inside text-sm text-gray-400">
            <li>이용자가 사전에 공개한 경우</li>
            <li>이용자가 연동에 동의한 경우</li>
            <li>
              이벤트 참가 시 정보제공 가능함을 미리 안내합니다. 부정확한
              개인정보 혹은 개인정보 누락 시 이벤트 당첨 등은 취소됩니다.
            </li>
          </ul>
        </h3>
        <h3 class="text-xl font-medium mt-4 mb-2">
          2) 법령의 규정에 의거하여 적법한 절차에 따른 요청이 있는 경우
          <ul class="list-disc list-inside text-sm text-gray-400">
            <li>
              법령의 규정에 의거하여 수사 목적으로 법령에 정해진 절차와 방법에
              따라 수사기관의 요구가 있는 경우
            </li>
            <li>
              법령의 규정에 의거하여 분쟁조정 등의 목적으로 법령에 정해진 절차와
              방법에 따라 관련기관의 요구가 있는 경우
            </li>
            <li>기타 법령의 규정에 의거한 경우</li>
          </ul>
        </h3>
        <h3 class="text-xl font-medium mt-4 mb-2">3) 기타</h3>
        <ul class="list-disc list-inside text-sm text-gray-400">
          <li>서비스 제공에 따른 요금 정산을 위하여 필요한 경우</li>
          <li>
            통계작성, 학술연구 또는 시장조사를 위하여 개인을 식별할 수 없는
            형태로 제공하는 경우
          </li>
          <li>
            정보주체 또는 그 법정대리인이 의사표시를 할 수 없는 상태에 있거나
            주소불명 등으로 사전 동의를 받을 수 없는 경우로서 명백히 정보주체
            또는 제3자의 급박한 생명, 신체, 재산의 이익을 위하여 필요하다고
            인정되는 경우
          </li>
        </ul>
        <h3 class="text-xl font-medium mt-4 mb-2">
          개인정보의 파기절차 및 방법
          <p className="text-sm text-gray-400 mb-2">
            이용자의 개인정보는 원칙적으로 개인정보 수집 및 이용목적이 달성된
            후에는 해당 정보를 지체없이 파기합니다. 파기절차 및 방법은 다음과
            같습니다.
          </p>
        </h3>
        <h3 class="text-xl font-medium mt-4 mb-2">
          1) 파기절차
          <p className="text-sm text-gray-400 mb-2">
            이용자가 회원가입 등을 위해 입력하신 정보는 목적이 달성된 후 별도의
            DB로 옮겨져(종이의 경우 별도의 서류함) 내부 방침 및 기타 관련 법령에
            의한 정보보호 사유에 따라(보유 및 이용기간 참조) 일정 기간 저장된 후
            파기됩니다. 동 개인정보는 법률에 의한 경우가 아니고는 다른 목적으로
            이용되지 않습니다.
          </p>
        </h3>
        <h3 class="text-xl font-medium mt-4 mb-2">
          2) 파기기준
          <ul class="list-disc list-inside text-sm text-gray-400">
            <li>이용자 본인 혹은 법정대리인의 회원탈퇴 요청</li>
            <li>
              {" "}
              한국인터넷진흥원, 본인확인기관 등의 개인정보 관련기관을 통한 회원
              탈퇴 요청
            </li>
            <li>
              개인정보 수집·이용 등에 대한 동의 철회 및 개인정보 삭제 또는 파기
              요청
            </li>
            <li>정보통신망법에 따른 장기 미이용자</li>
          </ul>
        </h3>
        <h3 class="text-xl font-medium mt-4 mb-2">
          3) 파기방법
          <ul class="list-disc list-inside text-sm text-gray-400">
            <li>
              전자적 파일형태로 저장된 개인정보는 기록을 재생할 수 없는 기술적
              방법을 사용하여 삭제
            </li>
            <li>
              종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기
            </li>
          </ul>
        </h3>
        <h3 class="text-xl font-medium mt-4 mb-2">
          회원 및 법정대리인의 권리와 그 행사방법
          <p className="text-sm text-gray-400 mb-2">
            회원 및 법정 대리인은 아래의 방법으로 언제든지 등록되어 있는 자신의
            개인정보를 조회하거나 수정 및 삭제할 수 있으며 개인정보 제공동의를
            철회하여 가입해지를 요청할 수도 있습니다. 혹은 회원 및 법정 대리인은
            고객센터나 개인정보책임자에게 서면, 전화 또는 이메일로 개인정보의
            조회, 수정, 삭제, 제공 동의 철회를 요청할 수 있습니다.
          </p>
          <p className="text-sm text-gray-400 mb-2">
            회원 혹은 법정대리인이 개인정보의 오류에 대한 정정을 요청하신
            경우에는 정정을 완료하기 전까지 당해 개인정보를 이용 또는 제공하지
            않습니다. 또한 잘못된 개인정보를 제3자에게 이미 제공한 경우에는 정정
            처리결과를 제3자에게 지체없이 통지하여 정정이 이루어지도록
            하겠습니다. 회사는 회원 혹은 법정 대리인의 요청에 의해 해지 또는
            삭제된 개인정보는 본 개인정보 처리방침에 명시된 바에 따라 처리하고
            그 외의 용도로 열람 또는 이용할 수 없도록 처리하고 있습니다.
          </p>
        </h3>
        <h3 class="text-xl font-medium mt-4 mb-2">
          개인정보의 기술적/관리적 보호대책
          <p className="text-sm text-gray-400 mb-2">
            회사는 회원들의 개인정보를 처리함에 있어 개인정보가 분실, 도난,
            누출, 변조 또는 훼손되지 않도록 안전성 확보를 위하여 다음과 같은
            기술적/관리적 대책을 강구하고 있습니다.
          </p>
        </h3>
        <h3 class="text-xl font-medium mt-4 mb-2">
          1) 해킹 등에 대비한 대책
          <p className="text-sm text-gray-400 mb-2">
            회사는 해킹이나 컴퓨터 바이러스 등에 의해 이용자의 개인정보가
            유출되거나 훼손되는 것을 막기 위해 최선을 다하고 있습니다.
            개인정보의 훼손에 대비해서 자료를 수시로 백업하고 있고, 최신
            보안솔루션을 이용하여 이용자들의 개인정보나 자료가 누출되거나
            손상되지 않도록 방지하고 있으며, 암호화통신 등을 통하여
            네트워크상에서 개인정보를 안전하게 전송할 수 있도록 하고 있습니다.
            그리고 침입차단시스템을 이용하여 외부로부터의 무단 접근을 통제하고
            있으며, 기타 시스템적으로 보안성을 확보하기 위한 가능한 모든 기술적
            장치를 갖추려 노력하고 있습니다.
          </p>
        </h3>
        <h3 class="text-xl font-medium mt-4 mb-2">
          2) 처리 직원의 최소화 및 교육
          <p className="text-sm text-gray-400 mb-2">
            회사의 개인정보관련 처리 직원은 담당자에 한정하며, 개인정보 상세
            조회가 가능한 계정은 권한 분리 조치와 보안조치를 취하였습니다. 이
            계정을 위한 별도의 비밀번호는 절차를 거쳐 정기적으로 갱신하고
            있으며, 담당자에 대한 수시 교육을 통해 개인정보 처리방침의 준수를
            항상 강조하고 있습니다.
          </p>
        </h3>
        <h3 class="text-xl font-medium mt-4 mb-2">
          3) 개인정보보호전담기구의 운영
          <p className="text-sm text-gray-400 mb-2">
            사내 개인정보보호전담기구 등을 통해 개인정보 처리방침의 이행 및
            담당자의 준수 여부를 확인하여 문제가 발견될 경우 즉시 수정하고
            바로잡을 수 있도록 노력하고 있습니다. 단, 회원 본인의 부주의나
            인터넷상의 문제로 개인정보가 유출되어 발생한 문제에 대해 회사는
            일체의 책임을 지지 않습니다.
          </p>
        </h3>
        <h3 class="text-xl font-medium mt-4 mb-2">
          개인정보에 관한 민원서비스
        </h3>
        <h3 class="text-xl font-medium mt-4 mb-2">
          1) 딥플랩스 민원서비스
          <p className="text-sm text-gray-400 mb-2">
            회사는 회원의 개인정보를 보호하고 개인정보와 관련한 불만을 처리하기
            위하여 아래와 같이 관련 부서 및 개인정보관리책임자를 지정하고
            있습니다. 회사는 접수하신 내용에 대해 신속하고 충분한 답변을 드리기
            위해 노력하고 있습니다. 고객서비스 담당부서의 운영시간은 평일 오전
            9시부터 오후 6시까지입니다. 개인정보 열람청구 업무는 ‘고객서비스
            담당부서’에서 담당하고 있습니다.
          </p>
          <ul class="list-disc list-inside text-sm text-gray-400">
            <li>
              개인정보 보호담당자
              <ul class="list-disc list-inside text-sm text-gray-400">
                <li>이 름 : 이혜진 차장</li>
                <li>메 일 : support@deepple.co.kr</li>
              </ul>
            </li>
          </ul>
          <ul class="list-disc list-inside text-sm text-gray-400">
            <li>
              개인정보 보호책임자
              <ul class="list-disc list-inside text-sm text-gray-400">
                <li>이 름 : 정호윤 과장</li>
                <li>메 일 : help@deepple.co.kr</li>
              </ul>
            </li>
          </ul>
        </h3>
        <h3 class="text-xl font-medium mt-4 mb-2">
          2) 기타 개인정보 관련 민원
          <p className="text-sm text-gray-400 mb-2">
            기타 개인정보침해에 대한 신고나 상담이 필요하신 경우에는 아래 기관에
            문의하시기 바랍니다.
          </p>
          <ul class="list-disc list-inside text-sm text-gray-400">
            <li>
              한국인터넷진흥원 개인정보보호 (
              <a
                href="https://www.kisa.or.kr/"
                target="_blank"
                rel="noopener noreferrer"
              >
                privacy.kisa.or.kr
              </a>{" "}
              국번없이 118)
            </li>
          </ul>
          <ul class="list-disc list-inside text-sm text-gray-400">
            <li>
              개인정보분쟁조정위원회 (
              <a
                href="https://kopico.go.kr/main/main.do"
                target="_blank"
                rel="noopener noreferrer"
              >
                kopico.go.kr/
              </a>{" "}
              1833-6972)
            </li>
          </ul>
          <ul class="list-disc list-inside text-sm text-gray-400">
            <li>
              정보보호마크인증위원회 (
              <a
                href="http://www.eprivacy.or.kr/"
                target="_blank"
                rel="noopener noreferrer"
              >
                www.eprivacy.or.kr/
              </a>{" "}
              02-580-0533~4)
            </li>
            <li>
              대검찰청 인터넷범죄수사센터 (
              <a
                href="http://www.spo.go.kr/"
                target="_blank"
                rel="noopener noreferrer"
              >
                대검찰청
              </a>{" "}
              국번없이 1301)
            </li>
          </ul>
          <ul class="list-disc list-inside text-sm text-gray-400">
            <li>
              경찰청 사이버안전국 (
              <a
                href="https://www.police.go.kr/www/security/cyber.jsp"
                target="_blank"
                rel="noopener noreferrer"
              >
                cyberbureau.police.go.kr/
              </a>{" "}
              국번없이 182)
            </li>
          </ul>
          <ul class="list-disc list-inside text-sm text-gray-400"></ul>
        </h3>
      </section>

      <footer class="mt-10 pt-6 border-t text-sm text-gray-600">
        <p>본 개인정보 처리방침은 2026년 4월 1일부터 적용됩니다.</p>
      </footer>
    </div>
  );
}

export default Privacy;
